import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SEND_ABSHER_FOR_UPDATE_MOBILE_ASYNC,
    Actions.SEND_ABSHER_FOR_UPDATE_MOBILE_SUCCESS,
    Actions.SEND_ABSHER_FOR_UPDATE_MOBILE_FAIL
  >,
): State => {
  switch (action.type) {
    case Actions.SEND_ABSHER_FOR_UPDATE_MOBILE_ASYNC:
    case Actions.SEND_ABSHER_FOR_UPDATE_MOBILE_SUCCESS:
    case Actions.SEND_ABSHER_FOR_UPDATE_MOBILE_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
